import { useQuery } from '@tcs/common/hooks/useQuery';
import { Representative } from '@tcs/client-portal-api/types/Representative';

interface Props {
  loading: boolean;
  data?: Representative;
}

export const useRepresentative = (representativeCode?: string): Props => {
  const { data, isLoading: loading } = useQuery<Representative, Error>(
    `/representatives/${representativeCode}`,
    {
      refetchOnMount: false,
      enabled: representativeCode !== undefined,
    }
  );
  return {
    loading,
    data,
  };
};

export default useRepresentative;
